import axios from 'axios';
import moment from 'moment';

import dayjs from 'dayjs';
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);


// viewportItemId, visibility, isDefault
export const SET_VIEWPORT_ITEM_LAST_STATE_VISIBILITY = 'SET_VIEWPORT_ITEM_LAST_STATE_VISIBILITY';
// viewportItemId, visibility, isDefault
export const SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY = 'SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY';
// viewportItemId, visibility, isDefault
export const SET_VIEWPORT_ITEM_CHART_VISIBILITY = 'SET_VIEWPORT_ITEM_CHART_VISIBILITY';
// viewportItemId, visibility, isDefault
export const SET_COMPARISON_TIME_VISIBILITY = 'SET_COMPARISON_TIME_VISIBILITY'
// viewportItemId, autoRefresh, updateFreqSec
export const SET_VIEWPORT_ITEM_AUTO_REFRESH = 'SET_VIEWPORT_ITEM_AUTO_REFRESH';

// timeout
export const FETCH_VIEWPORT_ITEM_SCHEDULED = 'FETCH_VIEWPORT_ITEM_SCHEDULED';

// new actions for viewportitem/id/basic-info/
// viewportItemId
export const FETCH_VIEWPORT_ITEM_BASIC_INFO_REQUEST = 'FETCH_VIEWPORT_ITEM_BASIC_INFO_REQUEST';
// viewportItemId, lastStateResponse, timeout
export const FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS = 'FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS';
// viewportItemId, error
export const FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR = 'FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR';

//
export const FETCH_VIEWPORT_ITEM_COMPARISON_SUCCESS = 'FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS';

// 
export const SET_DISPLAY_TIME_FILTERING = 'SET_DISPLAY_TIME_FILTERING';

export function fetchViewportItemBasicInfo(viewportItemId, dropHwm) {
  //if (viewportItemId == 1416) console.log("fetchViewportItemBasicInfo")
  // if (viewportItemId == 466) console.log("fetchViewportItemLocations( " + viewportItemId + " )") ;
  return (dispatch, getState) => {
    const apiURL = getState().ui.apiURL

    // TODO: check results of the previous fetch, and cancel / modify next fetches
    var hwm = 0 ;
    // fetch mo basic info (with last state and locations)
    if ( (getState().ui.itemLastStateVisible[viewportItemId] || getState().ui.itemTrajectoryVisible[viewportItemId])
       // when alread scheduled, start new request only if hwm should be modified
       && ( ! getState().ui.viewportItemTimeouts[viewportItemId]  || dropHwm ) ){

      var needsTrajectory = '' ;
      if (! getState().ui.itemTrajectoryVisible[viewportItemId]) needsTrajectory = '&limit=0' ;

      // time shift params:
      var shiftStartTo = ''
      var pst = getState().ui.viewportItemConfigs[viewportItemId].shiftStartTo
      // TODO: eliminate moment
      if (pst) {
        shiftStartTo = '&shiftStartTo=' + moment(pst, "YYYY-MM-DD HH:mm:ss").valueOf()
        //console.log(pst, '-->', moment(pst, "YYYY-MM-DD HH:mm:ss") )
      }
        
      var noFuture = ''
      if (getState().ui.viewportItemConfigs[viewportItemId].noFuture)
        noFuture = '&noFuture=' + getState().ui.viewportItemConfigs[viewportItemId].noFuture

      // hwm:
      if (! dropHwm) hwm =  getState().ui.viewportItemHwms[viewportItemId] ;
      //console.log("hwm:", viewportItemId, hwm)
      if (! hwm) hwm = 0  ;
      //console.log("FETCH_VIEWPORT_ITEM_BASIC_INFO_REQUEST:", viewportItemId )
      
      dispatch({type: FETCH_VIEWPORT_ITEM_BASIC_INFO_REQUEST, viewportItemId: viewportItemId })

      axios.get(`${apiURL}/viewportitem/${viewportItemId}/basic-info?hwm=${hwm}${needsTrajectory}${shiftStartTo}${noFuture}`)
      .then( response => {
        if (response.data.lastState)
          hwm = response.data.lastState.timeReceived
        else hwm = 0
        ga('send', 'event', 'API', 'FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS', 'success');
        dispatch( {
          type: FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS,
          viewportItemId: viewportItemId,
          infoResponse: response               // TODO: TUNING 
        } )
      })
      .catch( error => {
        console.log("ERROR", error)
        ga('send', 'event', 'API', 'FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR', 'failure');
        dispatch( { type: FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR,
          viewportItemId: viewportItemId,
          error: error } )
      })
      .then( response => {
        // finally
        if (getState().ui.itemAutoRefresh[viewportItemId]) {
          // schedule next fetch (regardles of the results of the previous)
          const updateFreqSec = getState().ui.itemUpdateFreqSec[viewportItemId]
          if ((updateFreqSec) && (updateFreqSec > 0)) {
            // clear previous timeout
            var timeout =  getState().ui.viewportItemTimeouts[viewportItemId] ;
            if (timeout) clearTimeout(timeout) ;
            // set a new one
            timeout = setTimeout( () => {
              dispatch( fetchViewportItemBasicInfo(viewportItemId) )
            }, updateFreqSec*1000);

            dispatch({type: FETCH_VIEWPORT_ITEM_SCHEDULED, viewportItemId: viewportItemId,
                      timeout: timeout, hwm: hwm })
          }
        }
      })
      .then( response => {
        // get comparison data, if provided:
        var compareTo = getState().ui.viewportItemConfigs[viewportItemId].compareTo ;
        if (compareTo && (! (viewportItemId in getState().ui.viewportItemComparisonData)) ) {
          axios.get(`${compareTo}`)
          .then( response => {
            ga('send', 'event', 'API', 'FETCH_VIEWPORT_ITEM_COMPARISON_SUCCESS', 'success');
            dispatch( {
              type: FETCH_VIEWPORT_ITEM_COMPARISON_SUCCESS,
              viewportItemId: viewportItemId,
              data: response.data
            } )
          })
          .catch( error => {
            console.log("ERROR", error)
          })
        }
      })
    }

  }
}


/*
*/
export function setViewportItemLastStateVisibility(viewportItemId, visibility, isDefault) {
  //if (viewportItemId == 1416) console.log("setViewportItemLastStateVisibility 1416", visibility, isDefault)
  //console.log('setViewportItemLastStateVisibility(' + viewportItemId + ', ' +
  //             visibility + ', ' + isDefault + ') ')
  if (!visibility & isDefault) visibility = false
  
  return (dispatch, getState) => {
    // first set visibility state, then schedule fetching data
    dispatch( {
      type: SET_VIEWPORT_ITEM_LAST_STATE_VISIBILITY,
      viewportItemId: viewportItemId,
      visibility: visibility,
      isDefault: isDefault
    } )

    //dispatch( fetchViewportItemLocations(viewportItemId) )
    // update removed
    //if (visibility) dispatch( fetchViewportItemBasicInfo(viewportItemId, false) )
  }
}

export function setViewportItemTrajectoryVisibility(viewportItemId, visibility, isDefault) {
  //if (viewportItemId == 1416) console.log("setViewportItemTrajectoryVisibility")

  //console.log('setViewportItemLastStateVisibility(' + viewportItemId + ', ' +
  //   visibility + ', ' + isDefault + ') ')
  if (!visibility & isDefault) visibility = false
  return (dispatch, getState) => {
    // first set visibility state, then schedule fetching data
    dispatch( {
      type: SET_VIEWPORT_ITEM_TRAJECTORY_VISIBILITY,
      viewportItemId: viewportItemId,
      visibility: visibility,
      isDefault: isDefault
    } )

    // dispatch( fetchViewportItemLocations(viewportItemId) )
    // if (visibility) dispatch( fetchViewportItemBasicInfo(viewportItemId, true) )
  }
}

export function setViewportItemChartVisibility(viewportItemId, visibility, isDefault) {
  if (!visibility & isDefault) visibility = false
  return (dispatch, getState) => {
    // first set visibility state, then schedule fetching data
    dispatch( {
      type: SET_VIEWPORT_ITEM_CHART_VISIBILITY,
      viewportItemId: viewportItemId,
      visibility: visibility,
      isDefault: isDefault
    } )

    //dispatch( fetchViewportItemBasicInfo(viewportItemId, false) )
  }
}
export function setComparisonTimeVisibility(viewportItemId, visibility, isDefault) {
  // console.log('setViewportItemLastStateVisibility(' + viewportItemId + ', ' +
  //   visibility + ', ' + isDefault + ') ')
  if (!visibility & isDefault) visibility = false
  return (dispatch, getState) => {
    // first set visibility state, then schedule fetching data
    dispatch( {
      type: SET_COMPARISON_TIME_VISIBILITY,
      viewportItemId: viewportItemId,
      visibility: visibility,
      isDefault: isDefault
    } )

    // dispatch( fetchViewportItemLocations(viewportItemId) )
    //dispatch( fetchViewportItemBasicInfo(viewportItemId, false) )
  }
}
